import React from 'react';
import { cn } from '../lib/utils';

export function GradeLynkLogo({ className, iconOnly = false }) {
  return (
    <div className={cn('inline-flex items-center gap-2.5', className)}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="220 50 360 360"
        className="h-8 w-8 sm:h-9 sm:w-9 flex-shrink-0 transition-transform duration-300 hover:scale-105"
      >
        {/* Main Navy "G" & Frame Structure - High Contrast in Light (#0f172a) & Dark (#ffffff) */}
        <path
          className="fill-slate-900 dark:fill-white transition-colors duration-300"
          fillRule="evenodd"
          d="
            M 550,165
            L 550,139
            A 64,64 0 0,0 486,75
            L 314,75
            A 64,64 0 0,0 250,139
            L 250,313
            A 62,62 0 0,0 312,375
            L 486,375
            A 64,64 0 0,0 550,311
            L 550,216
            L 429,216
            L 429,238.5
            L 333.2,334.3
            A 30,30 0 0,1 290.8,291.8
            L 411.3,171.3
            A 16,16 0 0,0 388.7,148.7
            L 282,255.4
            L 282,139
            A 32,32 0 0,1 314,107
            L 486,107
            A 32,32 0 0,1 518,139
            L 518,165
            Z

            M 518,311
            A 32,32 0 0,1 486,343
            L 370,343
            L 475.7,237.3
            L 518,237.3
            Z
          "
        />

        {/* Diagonal Yellow Arrow - High Contrast Gold in Light (#d97706/amber-600) & Dark (#fbbf24/amber-400) */}
        <path
          className="fill-amber-500 stroke-amber-500 dark:fill-amber-400 dark:stroke-amber-400 transition-colors duration-300"
          strokeWidth="3"
          strokeLinejoin="round"
          strokeLinecap="round"
          d="
            M 495,130
            L 425,130
            L 425,180.2
            L 298,307.2
            L 317.8,327
            L 444.8,200
            L 495,200
            Z
          "
        />
      </svg>

      {!iconOnly && (
        <span className="font-extrabold text-lg sm:text-xl tracking-tight text-slate-900 dark:text-white leading-none">
          Grade<span className="text-amber-600 dark:text-amber-400">Lynk</span>{' '}
          <span className="text-xs font-semibold text-slate-500 dark:text-slate-400 hidden sm:inline">Academy</span>
        </span>
      )}
    </div>
  );
}
